module.exports = __webpack_public_path__ + "img/badge-fresh.54ee8521.svg";